var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57 14.1077H3.6525L5.85 13.9052C6.1575 13.8752 6.4425 13.7402 6.66 13.5227L14.955 5.2277C15.345 4.8377 15.5625 4.3202 15.5625 3.7727C15.5625 3.2252 15.345 2.7077 14.955 2.3177L14.4225 1.7852C13.6425 1.0052 12.285 1.0052 11.505 1.7852L10.4475 2.8427L3.2175 10.0727C3 10.2902 2.865 10.5752 2.8425 10.8827L2.64 13.0802C2.6175 13.3577 2.715 13.6277 2.91 13.8302C3.09 14.0102 3.3225 14.1077 3.57 14.1077ZM12.9675 2.3027C13.2075 2.3027 13.4475 2.3927 13.6275 2.5802L14.16 3.1127C14.2476 3.19883 14.3172 3.30155 14.3647 3.41487C14.4122 3.52818 14.4367 3.64982 14.4367 3.7727C14.4367 3.89557 14.4122 4.01721 14.3647 4.13052C14.3172 4.24384 14.2476 4.34656 14.16 4.43269L13.5 5.09269L11.6475 3.2402L12.3075 2.5802C12.4875 2.4002 12.7275 2.3027 12.9675 2.3027ZM3.96 10.9877C3.96 10.9427 3.9825 10.9052 4.0125 10.8752L10.845 4.0352L12.6975 5.8877L5.865 12.7202C5.865 12.7202 5.79 12.7727 5.7525 12.7727L3.78 12.9527L3.96 10.9802V10.9877ZM17.0625 16.5002C17.0625 16.8077 16.8075 17.0627 16.5 17.0627H1.5C1.1925 17.0627 0.9375 16.8077 0.9375 16.5002C0.9375 16.1927 1.1925 15.9377 1.5 15.9377H16.5C16.8075 15.9377 17.0625 16.1927 17.0625 16.5002Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.276ee7b4a4ed1ee773440678ba31cea7.svg";
export { ForwardRef as ReactComponent };